import React from 'react';
import { Computer, LocationOn, EventAvailable } from '@mui/icons-material';
import { TeacherInfo } from '../../../types/TeacherInfo';
import './TeacherModality.css';

interface TeacherModalityProps {
  teacher: TeacherInfo;
}

const TeacherModality: React.FC<TeacherModalityProps> = ({ teacher }) => {
  return (
    <ul className="modalityList">
      {teacher.reservation_type === 'reservation_only' && (
        <li className="modalityItem">
          <EventAvailable className="modalityIcon" />
          <div className="modalityContent">
            <b className="itemTitle">Solo reserva</b>
            <span className="itemDescription">
              Señas tu horario, y el restante se lo pagas al profe
            </span>
          </div>
        </li>
      )}
      {teacher.configuration.virtual_classes && (
        <li className="modalityItem">
          <Computer className="modalityIcon" />
          <div className="modalityContent">
            <b className="itemTitle">Virtual</b>
            <span className="itemDescription">{teacher.configuration.virtual_classes_message}</span>
          </div>
        </li>
      )}
      {teacher.configuration.in_person_classes && (
        <li className="modalityItem">
          <LocationOn className="modalityIcon" />
          <div className="modalityContent">
            <b className="itemTitle">Presencial</b>
            <span className="itemDescription">
              {teacher.configuration.in_person_classes_message}
            </span>
          </div>
        </li>
      )}
    </ul>
  );
};

export default TeacherModality;
